import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: [ './notifications.component.scss' ]
})

export class NotificationsComponent implements OnInit {

  isOpen: boolean = false;

  constructor() {
  }

  onClick(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
  }

}
